import React, {useEffect, useState} from 'react';
import {
    ComposedChart,
    Bar,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Dot,
    ReferenceArea, ReferenceLine
} from 'recharts';
import moment from 'moment';


const ChartComponent = ({ data }) => {
    const limitedData = data

    // useEffect(() => {
    //    console.log(data)
    // },[])



    if (limitedData.length === 0) {
        return <div>No data available.</div>;
    }


    const chartData = limitedData.map(entry => ({
        dateTimeCreated: new Date(entry.dateTimeCreated).valueOf(),
        ...entry.presentedFields.reduce((acc, field) => {
            acc[field.fieldLabel] = parseFloat(field.measurementValue);
            return acc;
        }, {}),
    }));


    const xAxisDomain = [
        Math.min(...chartData.map(entry => entry.dateTimeCreated)),
        Math.max(...chartData.map(entry => entry.dateTimeCreated)),
    ];


    function getChartType(measurementType) {
        const lineTypes = ['HUMIDITY', 'TEMPERATURE'];
        const barTypes = ['PRECIPITATION', 'WET_LEAF', 'RAIN_AMOUNT'];

        if (lineTypes.includes(measurementType)) {
            return 'line';
        } else if (barTypes.includes(measurementType)) {
            return 'bar';
        } else {
            return 'line'; // Default to line for other types
        }
    }

    const measurementTypeColors = (measurementType) => {
        const colors = {
            TEMPERATURE: '#FF6347', // Tomato color for Temperature
            HUMIDITY: '#4682B4',    // SteelBlue color for Humidity
            RAIN_AMOUNT: '#32CD32'  // LimeGreen color for Rain Amount
        };

        // Return the color if the measurement type exists in the predefined list
        if (colors[measurementType]) {
            return colors[measurementType];
        }

        // Generate a random color if the measurement type is not in the list
        const randomColor = Math.floor(Math.random()*16777215).toString(16);
        return `#${randomColor}`;
    };


    const yAxisComponents = data[0].presentedFields.map((field, index, array) => {
        const chartType = getChartType(field.measurementType);
        const isSingle = array.length === 1;
        const isTwoSameType = array.length === 2 && chartType === getChartType(array[1].measurementType);
        const isMoreThanTwoSameType = array.length > 2 && array.every(item => getChartType(item.measurementType) === chartType);
        const color = measurementTypeColors(field.measurementType);

        return (
            <YAxis
                key={field.fieldLabel}
                // yAxisId={`axis-${index}`}
                yAxisId={field.measurementType}
                orientation={
                    isSingle
                        ? "left"
                        : isTwoSameType
                            ? index === 0
                                ? "left"
                                : "right"
                            : isMoreThanTwoSameType
                                ? index === 0
                                    ? "left"
                                    : "right"
                                : index % 2 === 0
                                    ? "left"
                                    : "right"
                }
                tick={{
                    // fill: chartType === 'bar' ? barChartColors[index % barChartColors.length] : lineChartColors[index % lineChartColors.length],
                    fill: color,
                    fontSize: chartType === 'bar' ? 12 : 10,
                }}
                margin={{ left: index % 2 !== 0 ? 0 : 10 }}
            />
        );
    });

    //reference lines and area for temperature below 0
    const renderZeroTemperatureMarker = (chartData) => {
        // Step 1: Find all active temperature fields
        // const temperatureFields = chartData?.presentedFields.filter(
        //     (field) => field.measurementType === 'TEMPERATURE'
        // );
        // console.log(chartData)

        // // Step 2: Calculate the minimum temperature value across all active fields
        // const temperatureData = temperatureFields.map((field) => {
        //     const key = field.fieldLabel;
        //     const values = chartData.map(d => d[key]).filter(v => typeof v === 'number');
        //     return { key, values };
        // });
        //
        // // Find the minimum temperature value across all fields
        // const minTempData = temperatureData
        //     .map(({ values }) => Math.min(...values))
        //     .reduce((min, curr) => (curr < min ? curr : min), Infinity);
        //
        // // Step 3: If no temperature is below 0, return null
        // if (minTempData > 0) return null;
        //
        // // Step 4: Find the field with the minimum temperature value
        // const minTempField = temperatureData.find(({ values }) =>
        //     Math.min(...values) === minTempData
        // );
        //
        // const minTempFieldKey = minTempField?.key;
        // const temperatureIndex = chartData[0]?.presentedFields.findIndex(
        //     (field) => field.fieldLabel === minTempFieldKey
        // );
        //
        // const temperatureYAxisId = temperatureIndex !== -1 ? `axis-${temperatureIndex}` : null;
        //
        // // Step 5: Render ReferenceLine and ReferenceArea for the field with the lowest value
        // return (
        //     <React.Fragment>
        //         <ReferenceArea
        //             yAxisId={temperatureYAxisId}
        //             y1={minTempData}
        //             y2={0}
        //             stroke="none"
        //             fill="lightblue"
        //             fillOpacity={0.3}
        //         />
        //         <ReferenceLine
        //             yAxisId={temperatureYAxisId}
        //             y={0}
        //             stroke="blue"
        //             strokeWidth={2}
        //             ifOverflow="visible"
        //         />
        //     </React.Fragment>
        // );
    };

    const chartComponents = data[0].presentedFields.map((field, index) => {
        const chartType = getChartType(field.measurementType);
        const color = measurementTypeColors(field.measurementType);
        if (chartType === 'bar') {
            return (
                <Bar
                    key={field.fieldLabel}
                    dataKey={field.fieldLabel}
                    fill={color}
                    // fill={barChartColors[index % barChartColors.length]}
                    barSize={15}
                    // yAxisId={`axis-${index}`}
                    yAxisId={field.measurementType}
                />
            );
        } else {
            return (
                <Line
                    key={field.fieldLabel}
                    type="monotone"
                    dataKey={field.fieldLabel}
                    // stroke={lineChartColors[index % lineChartColors.length]}
                    // dot={<Dot fill={lineChartColors[index % lineChartColors.length]} />}
                    stroke={color}
                    dot={<Dot fill={color} />}
                    // yAxisId={`axis-${index}`}
                    yAxisId={field.measurementType}
                />
            );
        }
    });


    return (
        <ResponsiveContainer width="100%" height="100%">
            <ComposedChart
                data={chartData}
                margin={{ top: 15, right: 0, left: -20, bottom: 5 }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                    dataKey="dateTimeCreated"
                    type="number"
                    scale="time"
                    padding={{ left: 20, right: 20 }}
                    domain={xAxisDomain}
                    tickFormatter={(unixTime) => {
                        const date = new Date(unixTime);
                        const formattedDate = date.toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: '2-digit'
                        });
                        const formattedTime = date.toLocaleTimeString('en-GB', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                        });

                        return `${formattedDate} ${formattedTime}`;
                    }}
                    interval={Math.ceil(limitedData.length /12)}
                    // tickCount={limitedData.length <= 10 ? limitedData.length : 10}
                    tick={{fontSize: 8}}
                />
                <Tooltip
                    labelFormatter={(value) => new Date(value).toLocaleString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                    })}
                />
                <Legend verticalAlign="bottom" align="center" />
                {/*{renderZeroTemperatureMarker(chartData)}*/}
                {yAxisComponents}
                {chartComponents}
            </ComposedChart>
        </ResponsiveContainer>
    );
};

export default ChartComponent;
